import { Merk } from "./merk";
import { ProductMetaData } from "./product-metadata";

export class ProductInfo {
  ok: boolean;
  productMetaData: ProductMetaData;
  merken: Merk[];
}